module.exports = __webpack_public_path__ + "static/img/homeprd2.47786b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/homeprd2.png
// module id = DLPW
// module chunks = 8